// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"efb01729","502":"aef14828","603":"1caf94a9","979":"a2df1016"}[chunkId] + ".chunk.css";
};